import { httpClient } from "@services/api/httpClient";

export async function updateOfferAssessment(offerId: number, questions: any[]) {
  const response = await httpClient.put(`/offer-assesment/update`, { offerId, questions });
  return response.data;
}